var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgCompanyDocuments = function SvgCompanyDocuments(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8E1538",
    d: "M52.196 38.406L43.28 50.47a1.298 1.298 0 0 1-1.971.14l-4.598-4.663a1 1 0 0 0-1.424 1.404l4.604 4.67a3.295 3.295 0 0 0 5-.366l8.912-12.06a1 1 0 1 0-1.608-1.19zM45 64c10.493 0 19-8.507 19-19s-8.507-19-19-19-19 8.507-19 19c0 10.496 8.501 19 19 19zm0-2c-9.394 0-17-7.608-17-17 0-9.389 7.611-17 17-17s17 7.611 17 17-7.611 17-17 17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B3A3A",
    fillRule: "nonzero",
    d: "M36.284 0c1.425 0 2.795.579 3.8 1.606l8.354 8.543A5.517 5.517 0 0 1 50 14.002v7.07a1 1 0 0 1-2 0v-7.07c0-.921-.358-1.807-.991-2.455l-8.355-8.543A3.319 3.319 0 0 0 36.284 2H5.361C3.51 2 2 3.542 2 5.46v49.08C2 56.456 3.508 58 5.361 58H20.64a1 1 0 0 1 0 2H5.36C2.393 60 0 57.55 0 54.54V5.46C0 2.447 2.396 0 5.361 0zM21 42a1 1 0 0 1 0 2H10a1 1 0 0 1 0-2zm0-13a1 1 0 0 1 0 2H10a1 1 0 0 1 0-2zm19-13a1 1 0 0 1 0 2H10a1 1 0 0 1 0-2z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompanyDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/company-documents.f9515caa.svg";
export { ForwardRef as ReactComponent };